import React, { useEffect, useState } from 'react';
import API from '../../../pages/Api';
import { fetchReactivateUsers } from '../../../pages/Services';
import TableContainer from '../../common/Tablecontainer';
import { toast } from 'react-toastify';
import { gender as genderMapping, residence as residenceMapping } from '../../../constant/constants';

const ReactivateUserCourse = () => {
    const [users, setUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [userCourses, setUserCourses] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);


    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const loadData = async () => {
        try {
            setLoading(true);
            const data = await fetchReactivateUsers();
            setUsers(Array.isArray(data) ? data : (data.results || []));
        } catch (err) {
            console.error("Data loading error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleViewClick = async (user, refreshTable) => {
        setSelectedUser({ ...user, refreshTableTrigger: refreshTable });
        setShowEditModal(true);
        setUserCourses([]);
        try {
            const userId = user.userid || user.userId;
            const res = await API.get(`getAllUserDtlsById?userId=${userId}`);
            setUserCourses(res.data.courseData || []);
        } catch (err) {
            console.error("Error fetching courses:", err);
            setUserCourses([]);
        }
    };

    const handleActivateCourse = async (course) => {
        if (course.status?.toUpperCase() === 'SUCCESS') return;
        if (!window.confirm(`Confirm activation for: ${course.courseName}?`)) return;

        try {
            const token = localStorage.getItem('access_token');
            const res = await API.post('admin/approve-pending-cash-transaction/', {
                paymentdataid: parseInt(course.paymentDataId, 10),
                targetCourseId: parseInt(course.courseId, 10)
            }, { headers: { 'Authorization': `Bearer ${token}` } });
            
            if (res.status === 200) {
                toast.success(res.data.message || "Action processed successfully!");
                setShowEditModal(false);
                if (selectedUser?.refreshTableTrigger) selectedUser.refreshTableTrigger();
            }
        } catch (err) {
            console.error("Activation dispatch error context:", err);
            toast.error("Oops! Activation pipeline failed.");
        }
    };
    if (loading && users.length === 0) return <div className="flex justify-center items-center h-60">Loading...</div>;
    const tableHeaders = ['Date', 'User Name', 'Email', 'Contact', 'Action'];

    return (
        <div className="p-2 md:p-4 bg-white min-h-screen w-full overflow-x-hidden">
        





            <h2
                className="
                text-center
                text-2xl
                md:text-4xl
                font-normal
                mb-6
                break-words
                px-2
                "
            >
                Reactivate Users Course
            </h2>
             <div className="mb-5 w-full">
                <input

                    type="text"
                    placeholder="Search Name / Email / Mobile"
                    value={searchQuery}
                    onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                    // className="w-full border rounded-lg p-3 outline-none max-w-full"
                    className="w-full
                    max-w-full
                    border
                    rounded-lg
                    p-3
                    outline-none
                    block
                    box-border"
                />
            </div>

            
            {isMobile ? (
                // MOBILE VIEW - List View
                <div className="space-y-4
                w-full
                px-0
                md:px-1">
                    {users.length > 0 ? (
                        users.map((user, index) => (
                            <div key={user.userid || index} className="bg-white
                            rounded-xl
                            shadow-sm
                            border
                            border-gray-200
                            p-4
                            w-full
                            max-w-full
                            transition-all
                            overflow-hidden
                            hover:shadow-md">
                                <div className="flex justify-between items-start mb-3 border-b border-gray-100 pb-2">
                                    <h3 className="font-bold text-[#032167] text-base leading-tight uppercase">
                                        {user.name}
                                    </h3>
                                    <span className="text-[10px] bg-blue-50 text-blue-700 px-2 py-0.5 rounded font-bold">
                                        #{index + 1}
                                    </span>
                                </div>

                                <div className="text-[13px] space-y-2 text-gray-600">
                                    <div className="flex gap-2 overflow-hidden">
                                        <span className="font-semibold text-gray-800 min-w-[70px]">
                                            Email:
                                        </span>

                                        <span className="flex-1
                                        break-all">
                                            {user.emailid}
                                        </span>
                                    </div>
                                    <div className="flex">
                                        <span className="font-semibold text-gray-800 w-20">Contact:</span> 
                                        <span>{user.mobileno || "-"}</span>
                                    </div>
                                    <div className="flex">
                                        <span className="font-semibold text-gray-800 w-20">Date:</span> 
                                        <span>{user.createddate ? new Date(user.createddate).toLocaleDateString('en-GB') : 'N/A'}</span>
                                    </div>
                                </div>

                                <button 
                                    onClick={() => handleViewClick(user, loadData)} 
                                    className="mt-5 w-full bg-[#032167] text-white py-2.5 rounded-lg text-xs font-bold uppercase tracking-widest hover:bg-blue-950 active:scale-[0.98] transition-all"
                                >
                                    View Details
                                </button>
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-10 text-gray-400 font-medium">No users found.</div>
                    )}

                    {/* REFINED MOBILE PAGINATION */}
                    <div className="flex justify-between items-center mt-6 mb-4 bg-white p-3 rounded-lg border border-gray-100 shadow-sm">
                        <button 
                            disabled={currentPage === 1} 
                            onClick={() => setCurrentPage(p => Math.max(1, p - 1))} 
                            className={`px-4 py-2 text-xs font-bold rounded-lg transition-all ${currentPage === 1 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-[#032167] text-white hover:bg-blue-950'}`}
                        >
                            Prev
                        </button>
                        
                        <span className="text-xs font-bold text-gray-600">
                            Page {currentPage} of {totalPages || 1}
                        </span>
                        
                        <button 
                            disabled={currentPage >= totalPages} 
                            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} 
                            className={`px-4 py-2 text-xs font-bold rounded-lg transition-all ${currentPage >= totalPages ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-[#032167] text-white hover:bg-blue-950'}`}
                        >
                            Next
                        </button>
                    </div>
                </div>
            ) : (
                <TableContainer
                    columns={tableHeaders}
                    apiUrl="admin/users/reactivate/"
                    renderRow={(user, index, srNo, refreshTable) => (
                        <tr key={user.userid || index} className="border-b border-gray-200 text-sm">
                            <td className="p-3 border-r font-semibold text-gray-500">{srNo}</td>
                            <td className="p-3 border-r text-center">
                                {user.createddate ? new Date(user.createddate).toLocaleDateString('en-GB') : 'N/A'}
                            </td>
                            
                            <td className="p-3 border-r font-bold text-blue-900 uppercase">{user.name}</td>
                            <td className="p-3 border-r">{user.emailid}</td>
                            <td className="p-3 border-r">{user.mobileno}</td>
                            <td className="p-3 text-center">
                                {/* 🟢 FIXED: Binding view click to pass the active network refresh token handle */}
                                <button 
                                    onClick={() => handleViewClick(user, refreshTable)} 
                                    className="bg-[#032167] text-white px-6 py-1 rounded text-xs font-bold uppercase hover:bg-blue-950 transition-all"
                                >
                                    View
                                </button>
                            </td>
                        </tr>
                    )}
                />
            )}

            {/* --- ACTIVATION MODAL WINDOW CONTROLS --- */}
            {showEditModal && selectedUser && (
                <div className="fixed inset-0 bg-slate-900/40 flex items-center justify-center z-[1000] px-2 py-4 md:p-4 backdrop-blur-md animate-fadeIn">
                    <div
                        className="
                            bg-white
                            w-[95%]
                            md:w-full
                            max-w-5xl
                            rounded-xl
                            shadow-2xl
                            flex
                            flex-col
                            max-h-[75vh]
                            md:max-h-[85vh]
                            border
                            border-gray-100
                            overflow-hidden
                            transform
                            transition-all
                            duration-300
                            scale-100
                        "
                    >
                        
                        {/* Modal Header */}
                        <div className="p-3 md:p-5 bg-gradient-to-r from-[#032167] to-[#0b3c4b] flex justify-between items-start md:items-center gap-3 text-white shadow-md">
                            <div>
                                <h3 className="font-extrabold tracking-wider uppercase text-xs text-blue-200">
                                    Register User Management Matrix
                                </h3>
                                <h2 className="font-semibold text-sm md:text-lg tracking-tight mt-0.5 break-words">
                                    Manage Course Activation Log: <span className="text-emerald-400 font-bold">{selectedUser.name}</span>
                                </h2>
                            </div>
                            <button 
                                onClick={() => setShowEditModal(false)} 
                                className="text-white hover:text-red-400 bg-white/10 hover:bg-white/20 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full text-xl font-light transition-all cursor-pointer shadow-inner flex-shrink-0"
                            >
                                &times;
                            </button>
                        </div>
                        
                        {/* Modal Body / Course Mapping Table */}
                        <div className="flex-1 overflow-auto bg-slate-50/50 p-3 md:p-6">
                            <div className="w-full overflow-x-auto bg-white rounded-xl border border-gray-200 shadow-sm">
                                <table className="min-w-full md:min-w-full w-full border-collapse text-center">
                                    <thead className="bg-slate-100 text-[10px] md:text-[11px] font-bold uppercase tracking-wider text-slate-500 border-b border-gray-200">
                                        <tr>
                                            <th className="py-4 px-5 border-r  text-left pl-6 font-semibold">Course Description</th>
                                            <th className="py-4 px-4 border-r font-semibold">Transaction Amount</th>
                                            <th className="py-4 px-4 border-r font-semibold">Duration </th>
                                            <th className="py-4 px-4 border-r font-semibold">Payment Status</th>
                                            <th className="py-4 px-6 border-r text-center font-semibold">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-xs md:text-[13px] divide-y divide-gray-100 font-medium text-slate-700">
                                        {userCourses.length > 0 ? userCourses.map((c, i) => (
                                            <tr 
                                                key={c.paymentDataId ? `${c.courseId}_${c.paymentDataId}` : `${c.courseId}_${i}`} 
                                                className="hover:bg-slate-50/80 transition-colors duration-150"
                                            >
                                                {/* courseDesc Mapping */}
                                                <td className="py-4 px-5 border-r text-left pl-6 font-bold text-slate-800 uppercase tracking-tight">
                                                    {c.courseName || "Pending Course"}
                                                </td>
                                                
                                                {/* Amount Mapping */}
                                                <td className="py-4 px-4 border-r font-mono font-bold text-slate-900 text-sm">
                                                    {selectedUser.residence !== "1" ? '₹' : '$'}
                                                    {c.amount && c.amount !== "None" ? parseFloat(c.amount).toFixed(2) : "0.00"}
                                                </td>
                                                
                                                {/* Duration Mapping */}
                                                <td className="py-4 px-4 border-r text-slate-500 font-semibold">
                                                    {c.duration ? `${c.duration} Days` : 'N/A'}
                                                </td>
                                                
                                                {/* PaymentStatus Badge Mapping */}
                                                <td className="py-4 px-4 border-r">
                                                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border ${
                                                        c.status?.toUpperCase() === 'SUCCESS' 
                                                            ? 'bg-emerald-50 text-emerald-700 border-emerald-200' 
                                                            : 'bg-amber-50 text-amber-700 border-amber-200'
                                                    }`}>
                                                        <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
                                                            c.status?.toUpperCase() === 'SUCCESS' ? 'bg-emerald-500' : 'bg-amber-500'
                                                        }`}></span>
                                                        {c.status?.toUpperCase() || 'PENDING'}
                                                    </span>
                                                </td>
                                                
                                                {/* Action Controller Mapping */}
                                                <td className="py-4 px-6 border-r text-center">
                                                    {c.status?.toUpperCase() === 'PENDING' && c.paymentDataId ? (
                                                        <button 
                                                            onClick={() => handleActivateCourse(c)} 
                                                            className="bg-emerald-600 text-white px-3 md:px-5 py-2 rounded-lg text-[10px] md:text-[11px] font-bold hover:bg-emerald-700 uppercase shadow-sm hover:shadow transition-all duration-150 cursor-pointer tracking-wider whitespace-nowrap"
                                                        >
                                                            Activate Now
                                                        </button>
                                                    ) : (
                                                        <span className="inline-flex items-center text-emerald-600 font-bold text-[11px] uppercase tracking-widest bg-emerald-50 px-2.5 py-1 rounded">
                                                            ✓ Activated
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan="5" className="py-12 text-center text-slate-400 font-medium text-sm bg-slate-200/10">
                                                    <div className="flex flex-col items-center justify-center space-y-2">
                                                        <span className="text-2xl">📋</span>
                                                        <span>No processing history course logs found for this user registry.</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReactivateUserCourse;